import { ConcreteEncodable } from "./ConcreteEncodable";

import { ApplicationMessageEventImplEncoder } from "../../encoder/ApplicationMessageEventImplEncoder";

import * as CubiqTS from "../../index";
import { ApplicationMessageEvent } from "../ApplicationMessageEvent";

export class ApplicationMessageEventImpl
  extends ConcreteEncodable
  implements ApplicationMessageEvent
{
  public static enType: string = "com.bcdfx.model.event.ApplicationMessageEventImpl";

  /*FID=1*/
  public messageType: string;
  /*FID=2*/
  public message: CubiqTS.Encodable | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ApplicationMessageEventImplEncoder.Instance;
    this.setEncodableType(ApplicationMessageEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ApplicationMessageEventImpl[" +
      "messageType=" +
      this.messageType +
      "message=" +
      this.message +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
